export const environment = {
  production: false,
  hmr: false,
  apiBackend: 'https://app-dev.quredigital.com/service/',
  apiToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJraW9zayJ9.tAHVUlYInFR5a7kUQliRwAov6QnCqI7pZgQz7Tm5vczDRByPcX5jZ55J1mM0RLWi98rRmxIJQuspxjwv1GT9bA',
  appsUrl: 'https://app-dev.quredigital.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
